import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1ba1b487")

_pushScopeId("data-v-1ba1b487")
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "KOKO",
  class: "logo"
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "fas fa-bars"
}
const _hoisted_4 = {
  key: 1,
  class: "fas fa-times"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode("div", {
      class: ["nav-options", { 'cover-screen': _ctx.openBurgerMenu }]
    }, [
      _createVNode("div", {
        class: "burger-menu",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openBurgerMenu = !_ctx.openBurgerMenu))
      }, [
        (!_ctx.openBurgerMenu)
          ? (_openBlock(), _createBlock("i", _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.openBurgerMenu)
          ? (_openBlock(), _createBlock("i", _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createVNode("ul", {
        class: { 'display-menu': _ctx.openBurgerMenu }
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navOptions, (option) => {
          return (_openBlock(), _createBlock("li", {
            key: option,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openBurgerMenu = false))
          }, [
            _createVNode(_component_router_link, {
              to: { name: option.toLowerCase(), params: null }
            }, {
              default: _withId(() => [
                _createVNode("span", null, _toDisplayString(option), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ], 2)
    ], 2)
  ]))
})